function formatLimitNumber(value: number) {
    return new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 }).format(value);
}

function formatKibiBytesAsBits(value: string | number, suffix: string) {
    const kibiBytes = Number(value);

    if (!kibiBytes) {
        return <i>0 or empty means unlimited</i>;
    }

    const kiloBits = (kibiBytes * 1024 * 8) / 1000;
    const megaBits = kiloBits / 1000;

    const equivalent =
        megaBits >= 1
            ? `${formatLimitNumber(megaBits)} Mbit${suffix} (${formatLimitNumber(kiloBits)} kbit${suffix})`
            : `${formatLimitNumber(kiloBits)} kbit${suffix}`;

    return (
        <>
            <i>Equivalent:</i> {equivalent}
        </>
    );
}

function rateDescription(value: string | number, text: string) {
    return (
        <>
            {text}
            <br />
            {formatKibiBytesAsBits(value, "/s")}
        </>
    );
}

export function averageDescription(value: string | number) {
    return rateDescription(value, "Sustained network interface limit.");
}

export function peakDescription(value: string | number) {
    return rateDescription(value, "Maximum speed allowed during a burst.");
}

export function burstDescription(value: string | number) {
    return (
        <>
            Amount of data allowed above the average rate before throttling resumes.
            <br />
            {formatKibiBytesAsBits(value, "")}
        </>
    );
}
